import '../../monitoring/filters/date/date_filter_view.js.coffee'

Namespace 'Surveys.Views.Filters'

class Surveys.Views.Filters.SurveyAnswerDateFilterView extends Monitoring.Views.SocialContents.Filters.DateFilterView

  initialize: ({searchQuery, title, filtersContainer}) ->
    super(searchQuery: searchQuery, filtersContainer: filtersContainer)
    @title = title || I18n.t('surveys.dashboard.filters.answered_at')

  _minDate: ->
    @_oldContentAwareMinDate()
